import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enButtons from '../locales/en/buttons.json';
import enCommon from '../locales/en/common.json';
import esButtons from '../locales/es/buttons.json';
import esCommon from '../locales/es/common.json';

export const defaultNS = 'common';
export const resources = {
  en: {
    common: enCommon,
    buttons: enButtons,
  },
  es: {
    common: esCommon,
    buttons: esButtons,
  },
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    defaultNS,
    ns: ['common', 'buttons'],
    resources,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export { default } from 'i18next';
